import axiosInstance from "../func/axiosInstance";

export const deletarTokenNoBack = async () => {
  const token = localStorage.getItem("token");
  if (!token) return;

  await axiosInstance.post("/logout", { token });
};